export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00863.9babe4e5.png";